<script>
export default {
  computed: {
    hasErrors() {
      return this.$store.getters.getCurrentErrorMessage !== null;
    },
    getCurrentErrorLevel () {
      return this.$store.getters.getCurrentErrorLevel;
    },
    getCurrentErrorMessage() {
      return this.$store.getters.getCurrentErrorMessage;
    },
    getCurrentErrorDescr() {
      return this.$store.getters.getCurrentErrorDescr;
    },
    getSelectedProducts() {
      return this.$store.getters.getSelectedProducts;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/mixins/OrderError_Mixin.vue